var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.741 16.03a5.807 5.807 0 01-4.075-1.662l-.003-.005c-.003 0-.006-.005-.008-.005a5.775 5.775 0 01-1.738-4.126c0-3.201 2.613-5.803 5.824-5.803s5.824 2.602 5.824 5.803c0 3.197-2.613 5.799-5.824 5.799zm0-13.03C9.74 3 6.482 6.245 6.482 10.232a7.18 7.18 0 001.679 4.617L3.21 19.78a.712.712 0 000 1.01c.14.139.323.21.507.21a.722.722 0 00.507-.21l4.959-4.94a7.238 7.238 0 004.557 1.61c4.003 0 7.259-3.245 7.259-7.228C21 6.245 17.744 3 13.741 3z"
  })));
};

export default SvgSearch;